<div>
    <form [formGroup]="customerDetailsForm">
        <div class="column__list">
            <div class="card__list">
                <div class="tooltip-container">
                    <app-vwsa-text-input label="ID number (if South African citizen)" maxLength="13" formControlName="idNumber" (onblur)="onValidateInput('idNumber',null)"
                        (valueChange)="onValidateInput('idNumber',$event)" validationMessage="{{idNumberValidationMessage}}">
                    </app-vwsa-text-input>
                    <app-tooltip class="tooltip-top-right" tooltipText="{{contentTooltips | ContentTooltip:'ID Number'}}"></app-tooltip>
                </div>
            </div>
            <div class="card__list">
                <app-vwsa-text-input label="Or Passport number (if foreign national)" isRequired="false" formControlName="passportNumber"
                    (onblur)="onValidateInput('passportNumber',null)" (valueChange)="onValidateInput('passportNumber',$event)"
                    validationMessage="{{passportNumberValidationMessage}}">
                </app-vwsa-text-input>
            </div>
            <div class="card__list">
                <div class="tooltip-container">
                    <app-vwsa-text-input label="VIN Number" maxLength="17" isRequired="true" formControlName="vin" (onblur)="onValidateInput('vin',null)"
                        (valueChange)="onValidateInput('vin',$event)" validationMessage="{{vinValidationMessage}}">
                    </app-vwsa-text-input>
                    <app-tooltip class="tooltip-top-right" tooltipText="{{contentTooltips | ContentTooltip:'VIN'}}"></app-tooltip>
                </div>
            </div>
        </div>
        <div>
            <app-vwsa-text appearance="copy0100" text="* Indicates required fields"></app-vwsa-text><br />
            <app-vwsa-button text="Continue" [disabled]="!customerDetailsForm.valid" (click)="onAuthenticateExistingCustomer()">
            </app-vwsa-button><br /><br />
            <app-vwsa-button text="Back" (click)="onBack()" variant="secondary"></app-vwsa-button>
        </div>
    </form>
</div>